import { render, staticRenderFns } from "./ECS1.vue?vue&type=template&id=642994f6&"
import script from "./ECS1.vue?vue&type=script&lang=js&"
export * from "./ECS1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports